interface CategoryReviewCardProps {
  catReview: any;
  hallName?: string;
}

const CategoryReviewCard: React.FC<any> = ({
  catReview,
  hallName,
}: CategoryReviewCardProps) => {
  return (
    <div className="flex flex-col gap-[8px]">
      <div className="category-rank flex items-center gap-[8px]">
        <span className="reviewLink small font-semibold text-grey300">
          {catReview?.questionTitle}
        </span>
        <div className="flex gap-[4px]">
          <div className="flex gap-[4px]">
            <svg
              data-testid="rating-svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.85874 1.14803C8.21796 0.0424542 9.78205 0.0424547 10.1413 1.14803L11.4248 5.09818C11.5854 5.59261 12.0462 5.92736 12.566 5.92736H16.7195C17.8819 5.92736 18.3653 7.4149 17.4248 8.09818L14.0646 10.5395C13.644 10.8451 13.468 11.3867 13.6287 11.8812L14.9122 15.8313C15.2714 16.9369 14.006 17.8562 13.0656 17.173L9.70535 14.7316C9.28477 14.426 8.71525 14.426 8.29466 14.7316L4.93446 17.173C3.994 17.8562 2.72863 16.9369 3.08785 15.8313L4.37133 11.8812C4.53198 11.3867 4.35599 10.8451 3.93541 10.5395L0.575205 8.09818C-0.365252 7.4149 0.118079 5.92736 1.28055 5.92736H5.43399C5.95386 5.92736 6.41461 5.59261 6.57525 5.09818L7.85874 1.14803Z"
                fill={"#0FBEFD"}
              />
            </svg>
          </div>
          <span className="small text-grey300">
            {Number(catReview?.rating)?.toFixed(1)}
          </span>
        </div>
      </div>
      {hallName &&
        catReview?.questionTitle?.toLowerCase() == "university halls" && (
          <div className="x-small text-grey300 mt-[-4px]">{hallName}</div>
        )}
      {catReview?.comments && (
        <p className="small text-grey300 break-words">{catReview?.comments}</p>
      )}
      {!!catReview?.childQuestions?.length && (
        <ul className="flex flex-wrap gap-x-[16px] gap-y-[4px] w-full p-[16px] *:text-small *:text-grey300 *:font-semibold bg-grey-100 rounded-[8px]">
          {catReview?.childQuestions?.map((childRev: any, idx: number) => (
            <li key={idx}>
              {childRev?.questionTitle}{" "}
              {childRev?.rating ? Number(childRev?.rating)?.toFixed(1) : "N/A"}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CategoryReviewCard;
